import { useForm } from "react-hook-form";
import TextInput from "./TextInput";
import PrimaryButton from "../PrimaryButton";
import PasswordInput from "./PasswordInput";
import Loading from "../Loading";
import SelectInput from "./SelectInput";
import TextareaInput from "./TextareaInput";
import DateInput from "./DateInput";
import CheckboxInput from "./CheckboxInput";
import FileInput from "./File";
import AffectedItems from "./AffectedItems";
import Remind from "./Remind";

function getDefaultValues(formInputs) {
  const value = {};
  formInputs?.forEach((formInput) => {
    const { name, defaultValue } = formInput;
    if (defaultValue) {
      value[name] = defaultValue;
    }
  });
  return value;
}

const MAP_INPUT = {
  text: TextInput,
  number: TextInput,
  password: PasswordInput,
  select: SelectInput,
  textarea: TextareaInput,
  date: DateInput,
  checkbox: CheckboxInput,
  affectedItems: AffectedItems,
  remind: Remind,
  file: FileInput,
};

function FormBuilder({
  formInputs,
  options,
  onSubmit,
  submitButtonLabel,
  isSubmitting,
  formContainerCls,
  submitBtnContainerCls = "",
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: getDefaultValues(formInputs),
  });
  return (
    <div>
      <form
        encType="multipart/form-data"
        onSubmit={handleSubmit(onSubmit)}
        className={`${formContainerCls}`}
      >
        {formInputs?.map((formInput, i) => {
          const {
            type,
            name,
            label,
            primaryLabel,
            placeholder,
            validation = {},
            inputProps = {},
            child,
            options,
            records,
            defaultValue,
            disabled,
          } = formInput;
          const InputComp = MAP_INPUT[type];
          return InputComp ? (
            <div key={i}>
              <InputComp
                inputProps={{
                  ...register(name, validation),
                  placeholder,
                  control,
                  disabled,
                }}
                label={label}
                primaryLabel={primaryLabel}
                error={errors[name]?.message}
                options={options}
                records={records}
                defaultValue={defaultValue}
                formInput={formInput}
              />
              {child}
            </div>
          ) : (
            "Invalid input type"
          );
        })}
        <div className={`my-7 ${submitBtnContainerCls}`}>
          <PrimaryButton
            buttonProps={{ type: "submit", disabled: isSubmitting }}
            btnCls=""
          >
            <div className="flex justify-center items-center">
              {isSubmitting ? <Loading /> : null}
              {submitButtonLabel || "Submit"}
            </div>
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
}

export default FormBuilder;
